import {useEffect, useState} from 'react';
import styles from './newAnnouncement.module.scss';
import backIcon from 'images/back.png';
import {
  Collapse,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Spin,
  Switch,
  Tabs,
} from 'antd';
import {useNavigate, useParams} from 'react-router-dom';
import {useMutation, useQuery} from '@apollo/client';
import SubmitButton from 'components/Startup/components/SubmitButton';
import moment from 'moment';
import {toast} from 'react-toastify';
import UploadImage from 'components/Startup/profile/companyImage';
import {UPDATE_ANNOUNCEMENT} from 'graphql/mutations/announcement';
import {
  GET_ALL_ANNOUNCEMENTS,
  GET_ANNOUNCEMENT,
} from 'graphql/queries/announcement';
import {announcementType} from 'utils/mock';
import {UploadVideoToBucket} from 'pages/campaigns/new/screens/legalDocument/uploadDocument';
import {BigPlayButton, Player} from 'video-react';
import {Button} from '@dabafinance/react-components';
import {GET_ALL_REPORT_ID} from 'graphql/queries/report';
import {GET_MINIMAL_CAMPAIGNS} from 'graphql/queries/campaign';
import {TRANSLATE_MULTIPLE_FIELDS} from 'graphql/queries/investorUpdates';
import {supportedLanguages} from 'utils/constants';
import {extractUserIds, onTranslateAnnouncement} from '../actions';
import {getUserTimezone} from 'utils/helper';
import {StepTwoAnnouncement} from '../popupAnnouncement/stepTwoAnnouncement';
import {FullScreenPopupAnnouncement} from '../fullScreenPopup/FullScreenPopupAnnouncement';
import {
  AnnouncementEntitySelector,
  isSingleEntityType,
} from '../components/AnnouncementEntitySelector';

const EditAnnouncement = () => {
  const [imgUrl, setImgUrl] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [announcementUrl, setAnnouncementUrl] = useState('');
  const [type, setType] = useState('');
  const [progress, setProgress] = useState(0);
  const [report, setReport] = useState('');
  const [opportunity, setOpportunity] = useState('');
  const [instrumentId, setInstrumentId] = useState('');
  const [collection, setCollection] = useState('');
  const [openUrl, setOpenUrl] = useState(false);
  const [videoUploadLoading, setVideoUploadLoading] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [videoUrlActive, setVideoUrlActive] = useState(false);
  const [audioFile, setAudioFile] = useState('');
  const [audioProgress, setAudioProgress] = useState(0);
  const [loadingAudioUpload, setLoadingAudioUpload] = useState(false);
  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState('');
  const [language, setLanguage] = useState('');
  const [selectedTranslationLanguage, setSelectedTranslationLanguage] =
    useState('');
  const [enableChangeTranslation, setEnableChangeTranslation] = useState(true);
  const [translatedAnnouncements, setTranslatedAnnouncements] = useState([]);
  const {Option} = Select;
  const navigate = useNavigate();
  const {id} = useParams();
  const [form] = Form.useForm();
  const translationSelected = Form.useWatch('translation', form);

  const {data, loading} = useQuery(GET_ANNOUNCEMENT, {
    variables: {
      announcementId: id,
    },
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
    onError: error => toast.error(error.message),
  });

  const [translateText, {loading: loadingTranslation}] = useMutation(
    TRANSLATE_MULTIPLE_FIELDS,
  );

  const handleChangeTranslatedValues = (key, event, name) => {
    let eventName = name;
    let eventValue = name ? event : event.target.value;
    const newFormValues = [...translatedAnnouncements];
    newFormValues[key][eventName] = eventValue;
    setTranslatedAnnouncements(newFormValues);
  };

  const handleTranslation = async () => {
    const translateProps = {
      sourceLang: language,
      targetLang: selectedTranslationLanguage,
      targetText1: title,
      targetText2: subTitle,
    };
    try {
      const newValues = [...translatedAnnouncements];

      //Check if translation exists
      if (newValues.length && newValues[0]) {
        // Check if we're trying to translate in the same language
        const languageExists = newValues.some(
          data => data.language === selectedTranslationLanguage,
        );
        if (languageExists) {
          const updateTranslation = await onTranslateAnnouncement(
            translateText,
            translateProps,
          );
          const translationIndex = newValues.findIndex(
            data => data.language === selectedTranslationLanguage,
          );
          newValues[translationIndex].title = updateTranslation.title;
          newValues[translationIndex].subTitle = updateTranslation.subTitle;
          newValues[translationIndex].language = updateTranslation.language;
          newValues[translationIndex].audioFile = '';
          newValues[translationIndex].loadingAudioUpload = false;
          newValues[translationIndex].audioProgress = 0;
          newValues[translationIndex].imageUrl = '';
          newValues[translationIndex].previewUrl = '';
          setTranslatedAnnouncements(newValues);
        }
      } else {
        const triggerTranslation = await onTranslateAnnouncement(
          translateText,
          translateProps,
        );
        if (!triggerTranslation) {
          return toast.error('Something went wrong when Translating');
        }
        newValues.push(triggerTranslation);
        setTranslatedAnnouncements(newValues);
        setTranslatedAnnouncements(newValues);
      }
    } catch (error) {
      toast.error('Something went wrong!');
    }
  };

  const setMultilangPreview = (url, index) => {
    const newValues = [...translatedAnnouncements];
    newValues[index].previewUrl = url;
    setTranslatedAnnouncements(newValues);
  };

  const setMultilangImageUrl = (url, index) => {
    const newValues = [...translatedAnnouncements];
    newValues[index].imageUrl = url;
    setTranslatedAnnouncements(newValues);
  };

  useEffect(() => {
    if (data?.getAnnouncement?.announcement) {
      // Full screen popups are edited by their own wizard below — skip the
      // legacy hydration so we don't set unused state on this form.
      if (
        data?.getAnnouncement?.announcement?.displayType === 'FULL_SCREEN_POPUP'
      ) {
        return;
      }
      const {signUpTime, lastAppVisit, transaction, kycStatus, ...rest} =
        data?.getAnnouncement?.announcement?.targetAudience || {};
      const {
        instrumentKeys,
        instrumentIds,
        directions,
        statuses,
        startDate,
        endDate,
      } = transaction || {};
      form.setFieldsValue({
        ...rest,
        expiredDate: data?.getAnnouncement?.announcement?.expiredDate
          ? moment(data?.getAnnouncement?.announcement?.expiredDate)
          : null,
        publishedDate: data?.getAnnouncement?.announcement?.publishedDate
          ? moment(data?.getAnnouncement?.announcement?.publishedDate)
          : null,
        signupStartDate: signUpTime?.start ? moment(signUpTime?.start) : null,
        instrumentKeys: instrumentKeys ? instrumentKeys : null,
        instrumentIds: instrumentIds ? instrumentIds : null,
        directions: directions ? directions : null,
        statuses: statuses ? statuses : null,
        signupEndDate: signUpTime?.end ? moment(signUpTime?.end) : null,
        identityCheck: kycStatus?.identityCheck
          ? kycStatus?.identityCheck
          : null,
        documentCheck: kycStatus?.documentCheck
          ? kycStatus?.documentCheck
          : null,
        amlCheck: kycStatus?.amlCheck ? kycStatus?.amlCheck : null,
        lastAppVisitedStartDate: lastAppVisit?.start
          ? moment(lastAppVisit?.start)
          : null,
        lastAppVisitedEndDate: lastAppVisit?.end
          ? moment(lastAppVisit?.end)
          : null,
        investmentStartDate: startDate ? moment(startDate) : null,
        investmentEndDate: endDate ? moment(endDate) : null,
      });
      setImgUrl(data?.getAnnouncement?.announcement?.imageUrl);
      setPreviewUrl(data?.getAnnouncement?.announcement?.imageUrl);
      setType(data?.getAnnouncement?.announcement?.type);
      setAudioFile(data?.getAnnouncement?.announcement?.audioUrl);
      setTitle(data?.getAnnouncement?.announcement?.title);
      setSubTitle(data?.getAnnouncement?.announcement?.subTitle);
      setLanguage(data?.getAnnouncement?.announcement?.language || 'EN');
      setOpenUrl(data?.getAnnouncement?.announcement?.openUrlOnClick);
      setAnnouncementUrl(data?.getAnnouncement?.announcement?.announcementUrl);
      setVideoUrl(data?.getAnnouncement?.announcement?.announcementUrl);
      setReport(data?.getAnnouncement?.announcement?.report?.id);
      setOpportunity(data?.getAnnouncement?.announcement?.opportunity?.id);
      // Hydrate from the Instrument v2 scalar. `Announcement.instrument` is
      // the federated object for display; the id is what a save resubmits.
      setInstrumentId(
        data?.getAnnouncement?.announcement?.instrumentId ??
          data?.getAnnouncement?.announcement?.instrument?.id,
      );
      setCollection(data?.getAnnouncement?.announcement?.collection?.id);
      // The picker reads from the form store, not from local state, so the
      // destination has to be seeded here too. `company` and `instrument` are
      // gone — `instrumentId` is the Instrument v2 destination.
      form.setFieldsValue({
        instrumentId:
          data?.getAnnouncement?.announcement?.instrumentId ??
          data?.getAnnouncement?.announcement?.instrument?.id,
        // SINGLE_OPPORTUNITY covers three instrument families; the saved
        // instrument's own key says which picker to show.
        opportunityKind: data?.getAnnouncement?.announcement?.instrument?.key,
        collection: data?.getAnnouncement?.announcement?.collection?.id,
      });
      form.setFieldsValue({
        actionButtonText:
          data?.getAnnouncement?.announcement?.actionButtonLabel,
        dismissible:
          data?.getAnnouncement?.announcement?.popupConfig?.dismissible,
        maxShowCount:
          data?.getAnnouncement?.announcement?.popupConfig?.maxShowCount,
      });

      if (data?.getAnnouncement?.announcement?.multiLang?.length > 0) {
        setSelectedTranslationLanguage(
          data?.getAnnouncement?.announcement?.multiLang[0]?.language,
        );
        form.setFieldsValue({
          translation:
            data?.getAnnouncement?.announcement?.multiLang[0]?.language,
        });
        setTranslatedAnnouncements(
          data?.getAnnouncement?.announcement?.multiLang?.map(data => ({
            audioFile: data?.audioUrl,
            title: data?.title,
            subTitle: data?.subTitle,
            language: data?.language,
            previewUrl: data?.imageUrl,
            imageUrl: data?.imageUrl,
            announcementUrl: data?.announcementUrl,
            actionButtonText: data?.actionButtonLabel,
          })),
        );
      }
    }
  }, [data?.getAnnouncement?.announcement]);

  const [updateAnnouncement, {loading: creating}] =
    useMutation(UPDATE_ANNOUNCEMENT);

  const {data: getAllReports} = useQuery(GET_ALL_REPORT_ID, {
    errorPolicy: 'all',
    onError: error => toast.error(error.message),
  });

  const {data: getAllCampaigns} = useQuery(GET_MINIMAL_CAMPAIGNS);

  const fieldWidth = 730;

  const handleSave = values => {
    const {
      lastAppVisitedStartDate,
      lastAppVisitedEndDate,
      userSegments,
      riskProfiles,
      identityCheck,
      documentCheck,
      amlCheck,
      countriesOfInterest,
      countryCodes,
      signupStartDate,
      signupEndDate,
      investmentStartDate,
      investmentEndDate,
      instrumentKeys,
      directions,
      statuses,
      audienceInstrumentId,
      stockId,
      ventureAssetId,
      userIds,
    } = values;
    const instrumentIds = [
      audienceInstrumentId,
      stockId,
      ventureAssetId,
    ].filter(Boolean);
    updateAnnouncement({
      variables: {
        data: {
          announcementId: id,
          type,
          imageUrl: imgUrl,
          openUrlOnClick: openUrl,
          ...(audioFile && {audioUrl: audioFile}),
          announcementUrl,
          report,
          // Instrument v2. `company` and `instrument` are rejected on dev, and
          // SINGLE_OPPORTUNITY accepts exactly one of `opportunity` (legacy
          // campaign) or `instrumentId`.
          ...(instrumentId ? {instrumentId} : opportunity ? {opportunity} : {}),
          ...(type === 'SINGLE_COLLECTION' && {collection}),
          publishedDate: values?.publishedDate
            ? moment(values?.publishedDate).format()
            : null,
          popupConfig: {
            dismissible: values.dismissible,
            maxShowCount: values.maxShowCount,
          },
          expiredDate: values?.expiredDate
            ? moment(values?.expiredDate).format()
            : null,
          actionButtonLabel: values.actionButtonText,
          title,
          subTitle,
          targetAudience: {
            lastAppVisit: {
              ...(lastAppVisitedStartDate && {
                start: moment(lastAppVisitedStartDate).format(),
              }),
              ...(lastAppVisitedEndDate && {
                end: moment(lastAppVisitedEndDate).format(),
              }),
            },
            userSegments,
            riskProfiles,
            countryCodes,
            ...(userIds?.length && {userIds: extractUserIds(userIds)}),
            kycStatus: {
              identityCheck,
              documentCheck,
              amlCheck,
            },
            countriesOfInterest,
            signUpTime: {
              ...(signupStartDate && {
                start: moment(signupStartDate).format(),
              }),
              ...(signupEndDate && {
                end: moment(signupEndDate).format(),
              }),
            },
            transaction: {
              directions,
              statuses,
              ...(investmentStartDate && {
                startDate: moment(investmentStartDate).format(),
              }),
              ...(investmentEndDate && {
                endDate: moment(investmentEndDate).format(),
              }),
              instrumentKeys,
              instrumentIds,
            },
          },
          language,
          multiLang: translatedAnnouncements.map(item => ({
            ...(audioFile && {audioUrl: audioFile}),
            imageUrl: item?.imageUrl,
            actionButtonLabel: item?.actionButtonText,
            language: item?.language,
            title: item?.title,
            subTitle: item?.subTitle,
            announcementUrl,
          })),
        },
      },
      refetchQueries: [{query: GET_ALL_ANNOUNCEMENTS}],
    }).then(({data: {updateAnnouncement}}) => {
      if (updateAnnouncement.__typename === 'Error') {
        toast.error(updateAnnouncement.message);
      } else {
        toast.success('Announcement updated successfully');
        navigate('/dashboard/announcements');
      }
    });
  };

  const handleUploadVideo = async e => {
    const selectedFile = e.target.files[0];
    if (selectedFile.type === 'video/mp4') {
      setVideoUploadLoading(true);
      const response = await UploadVideoToBucket(
        selectedFile,
        'annoucement-images',
        setProgress,
      );
      setVideoUrl(response);
      setAnnouncementUrl(response);
      setVideoUploadLoading(false);
      setProgress(0);
    } else {
      toast.error('Please upload a mp4 video');
    }
  };

  const handleUploadAudio = async e => {
    const selectedFile = e.target.files[0];
    setLoadingAudioUpload(true);
    const response = await UploadVideoToBucket(
      selectedFile,
      'annoucement-images',
      setAudioProgress,
    );
    setAudioFile(response);
    setLoadingAudioUpload(false);
  };

  const handleUploadMultilangAudio = async (e, index) => {
    const selectedFile = e.target.files[0];
    const newFormValues = [...translatedAnnouncements];
    newFormValues[index].loadingAudioUpload = true;
    setTranslatedAnnouncements(newFormValues);
    const updatedFormValues = [...translatedAnnouncements];
    const response = await UploadVideoToBucket(
      selectedFile,
      'annoucement-images',
      () => {},
    );
    updatedFormValues[index].audioFile = response;
    updatedFormValues[index].loadingAudioUpload = false;
    setTranslatedAnnouncements(updatedFormValues);
  };

  const languageToBeTranslatedTo = supportedLanguages.filter(
    key => key.value !== language,
  );

  if (loading) {
    return (
      <div className={styles.loading}>
        <Spin size="large" />
        <h1>Loading...</h1>
      </div>
    );
  }

  // Full screen popups have their own multi-step editor.
  if (
    data?.getAnnouncement?.announcement?.displayType === 'FULL_SCREEN_POPUP'
  ) {
    return <FullScreenPopupAnnouncement editId={id} />;
  }

  return (
    <div>
      <div className={styles.navigation}>
        <img src={backIcon} alt="Go back" onClick={() => navigate(-1)} />
        <span>
          <span className={styles['h-style']}>Edit Announcement</span>
        </span>
      </div>
      <div className={styles.form}>
        <span className={styles.note}>*Recommended size is 327px X 158px*</span>
        <UploadImage
          previewUrl={previewUrl}
          setPreviewUrl={setPreviewUrl}
          setImgUrl={setImgUrl}
          large
          bucket="annoucement-images"
        />
        <Form form={form} onFinish={handleSave} layout="vertical">
          <Form.Item label="Language" className={styles.field} name="language">
            <Select
              style={{width: fieldWidth}}
              value={language}
              defaultValue={data?.getAnnouncement?.announcement?.language}
              onChange={e => setLanguage(e)}>
              {supportedLanguages.map(data => (
                <Option key={data.value}>{data.label}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Announcement Type"
            className={styles.field}
            name="type"
            rules={[
              {
                required: true,
              },
            ]}
            initialValue={data?.getAnnouncement?.announcement?.type}>
            <Select
              style={{width: fieldWidth}}
              value={type}
              showSearch
              defaultValue={data?.getAnnouncement?.announcement?.type}
              onChange={e => setType(e)}>
              {announcementType.map(({key, name}) => (
                // eslint-disable-next-line react/jsx-key
                <Option value={key}>{name}</Option>
              ))}
            </Select>
          </Form.Item>
          <>
            <Form.Item
              label="Language Translation"
              className={styles.field}
              name="translation">
              <Select
                style={{width: fieldWidth}}
                value={selectedTranslationLanguage}
                defaultValue={
                  data?.getAnnouncement?.announcement?.multiLang[0]?.language
                }
                onChange={e => {
                  setSelectedTranslationLanguage(e);
                  setTranslatedAnnouncements([
                    {
                      language: e,
                    },
                  ]);
                }}>
                {languageToBeTranslatedTo.map(data => (
                  <Option key={data.value}>{data.label}</Option>
                ))}
              </Select>
            </Form.Item>
            {type === 'SINGLE_REPORT' && (
              <Form.Item
                label="Report"
                className={styles.field}
                name="report"
                rules={[
                  {
                    required: true,
                  },
                ]}
                initialValue={data?.getAnnouncement?.announcement?.report?.id}>
                <Select
                  style={{width: fieldWidth}}
                  value={report}
                  onChange={e => setReport(e)}
                  defaultValue={
                    data?.getAnnouncement?.announcement?.report?.id
                  }>
                  {getAllReports?.getAllReports?.map(({id, title}) => (
                    // eslint-disable-next-line react/jsx-key
                    <Option value={id}>{title}</Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            {type === 'SINGLE_OPPORTUNITY' && (
              <Form.Item
                label="Campaign"
                className={styles.field}
                name="opportunity"
                rules={[
                  {
                    required: true,
                  },
                ]}
                initialValue={
                  data?.getAnnouncement?.announcement?.opportunity?.id
                }>
                <Select
                  style={{width: fieldWidth}}
                  value={opportunity}
                  onChange={e => setOpportunity(e)}
                  defaultValue={
                    data?.getAnnouncement?.announcement?.opportunity?.id
                  }>
                  {getAllCampaigns?.getAllCampaigns?.campaigns
                    ?.filter(
                      data =>
                        data?.campaignStatus === 'ACTIVE' &&
                        data?.campaignMode === 'LIVE',
                    )
                    .map(({id, fundraisingCompany}) => (
                      // eslint-disable-next-line react/jsx-key
                      <Option value={id}>
                        <div className={styles['all-data']}>
                          <img src={fundraisingCompany?.logoImgURL} alt="" />
                          <span>{fundraisingCompany?.companyName}</span>
                        </div>
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            )}
            {isSingleEntityType(type) && (
              <AnnouncementEntitySelector
                type={type}
                width={fieldWidth}
                onSelect={(field, value) => {
                  if (field === 'instrumentId') setInstrumentId(value);
                  if (field === 'collection') setCollection(value);
                }}
              />
            )}
            {data?.getAnnouncement?.announcement?.displayType === 'POPUP' && (
              <>
                <Form.Item
                  label="Dismissible"
                  name="dismissible"
                  className={styles.field}>
                  <Switch
                    defaultChecked={
                      data?.getAnnouncement?.announcement?.popupConfig
                        ?.dismissible
                    }
                  />
                </Form.Item>
                <Form.Item name="maxShowCount" label="Max Show Count">
                  <InputNumber
                    min={1}
                    max={100}
                    className="input-number"
                    defaultValue={
                      data?.getAnnouncement?.announcement?.popupConfig
                        ?.maxShowCount
                    }
                  />
                </Form.Item>
              </>
            )}
            <Tabs
              className={styles.tabs}
              tabBarExtraContent={
                selectedTranslationLanguage && (
                  <Button
                    disabled={!title || !subTitle || loadingTranslation}
                    label="Translate"
                    onClick={handleTranslation}
                  />
                )
              }>
              <Tabs.TabPane tab="Original" key="Original">
                {(type === 'AUDIO' ||
                  data?.getAnnouncement?.announcement?.displayType ===
                    'POPUP') && (
                  <>
                    <Form.Item
                      rules={[
                        {
                          required: false,
                        },
                      ]}
                      label="Title"
                      className={styles.field}
                      name="title">
                      <Input
                        style={{width: fieldWidth}}
                        value={title}
                        defaultValue={
                          data?.getAnnouncement?.announcement?.title
                        }
                        onChange={e => setTitle(e.target.value)}
                        placeholder={'title'}
                      />
                    </Form.Item>
                    <Form.Item
                      rules={[
                        {
                          required: false,
                        },
                      ]}
                      label="Subtitle"
                      className={styles.field}
                      name="subTitle">
                      <Input.TextArea
                        style={{width: fieldWidth}}
                        value={subTitle}
                        defaultValue={
                          data?.getAnnouncement?.announcement?.subTitle
                        }
                        rows={5}
                        onChange={e => setSubTitle(e.target.value)}
                      />
                    </Form.Item>
                    <>
                      {type === 'AUDIO' && (
                        <>
                          {audioFile ? (
                            <div className={styles['audio-file']}>
                              <audio controls src={audioFile} />
                              <Button
                                label="Delete File"
                                onClick={() => {
                                  setAudioFile('');
                                  setAudioProgress(0);
                                }}
                              />
                            </div>
                          ) : (
                            <div>
                              <label
                                className={styles.upload}
                                htmlFor="file-upload">
                                {loadingAudioUpload ? (
                                  <div className={styles.uploading}>
                                    <Spin />
                                    <h3>Uploading, Please wait...</h3>
                                    <span>{audioProgress}%</span>
                                  </div>
                                ) : (
                                  <h2>Upload Audio or Recording</h2>
                                )}
                                <input
                                  type="file"
                                  id="file-upload"
                                  accept="audio/mpeg"
                                  className={styles['input-file']}
                                  onChange={handleUploadAudio}
                                />
                              </label>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  </>
                )}
                <Form.Item
                  rules={[{max: 20, message: 'Max 20 characters'}]}
                  name="actionButtonText"
                  label="Action Button Text">
                  <Input
                    style={{width: fieldWidth}}
                    placeholder={'Action Button Text'}
                  />
                </Form.Item>
              </Tabs.TabPane>
              {translationSelected &&
                translatedAnnouncements.map((announcement, index) => (
                  <Tabs.TabPane
                    key={announcement.language}
                    tab={
                      supportedLanguages.find(
                        lang => lang.value === announcement.language,
                      ).label
                    }>
                    <div className={styles.updateButton}>
                      <Button
                        onClick={() =>
                          setEnableChangeTranslation(!enableChangeTranslation)
                        }
                        type="secondary"
                        label={
                          enableChangeTranslation
                            ? 'Edit Translation'
                            : 'Disable Translation'
                        }
                      />
                    </div>
                    <div key={index}>
                      <span className={styles.note}>
                        *Recommended size is 327px X 158px*
                      </span>
                      <UploadImage
                        previewUrl={announcement.previewUrl}
                        setPreviewUrl={e => setMultilangPreview(e, index)}
                        setImgUrl={e => setMultilangImageUrl(e, index)}
                        large
                        bucket="annoucement-images"
                      />
                      {(type === 'AUDIO' ||
                        data?.getAnnouncement?.announcement?.displayType ===
                          'POPUP') && (
                        <>
                          <Form.Item label="Title" className={styles.field}>
                            <Input
                              style={{width: fieldWidth}}
                              value={announcement.title}
                              disabled={enableChangeTranslation}
                              onChange={e =>
                                handleChangeTranslatedValues(
                                  index,
                                  e.target.value,
                                  'title',
                                )
                              }
                              placeholder={'title'}
                            />
                          </Form.Item>
                          <Form.Item label="Subtitle" className={styles.field}>
                            <Input.TextArea
                              style={{width: fieldWidth}}
                              value={announcement.subTitle}
                              disabled={enableChangeTranslation}
                              onChange={e =>
                                handleChangeTranslatedValues(
                                  index,
                                  e.target.value,
                                  'subTitle',
                                )
                              }
                              rows={5}
                            />
                          </Form.Item>
                          <>
                            {type === 'AUDIO' && (
                              <>
                                {announcement.audioFile ? (
                                  <div className={styles['audio-file']}>
                                    <audio
                                      controls
                                      src={announcement.audioFile}
                                    />
                                    <Button
                                      label="Delete File"
                                      onClick={() => {
                                        announcement.audioFile = '';
                                        announcement.audioProgress = 0;
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <div>
                                    <label
                                      className={styles.upload}
                                      htmlFor="file-upload">
                                      {announcement.loadingAudioUpload ? (
                                        <div className={styles.uploading}>
                                          <Spin />
                                          <h3>Uploading, Please wait...</h3>
                                          <span>
                                            {announcement.audioProgress}%
                                          </span>
                                        </div>
                                      ) : (
                                        <h2>Upload Audio or Recording</h2>
                                      )}
                                      <input
                                        type="file"
                                        id="file-upload"
                                        accept="audio/mpeg"
                                        className={styles['input-file']}
                                        onChange={e =>
                                          handleUploadMultilangAudio(e, index)
                                        }
                                      />
                                    </label>
                                  </div>
                                )}
                              </>
                            )}
                          </>
                        </>
                      )}
                      <Form.Item
                        label="Translated Action Button Text"
                        className={styles.field}>
                        <Input
                          style={{width: fieldWidth}}
                          value={announcement.actionButtonText}
                          onChange={e =>
                            handleChangeTranslatedValues(
                              index,
                              e.target.value,
                              'actionButtonText',
                            )
                          }
                          placeholder="Enter translated action button text"
                        />
                      </Form.Item>
                    </div>
                  </Tabs.TabPane>
                ))}
            </Tabs>
          </>

          {type === 'VIDEO' && (
            <div>
              <Form.Item label="Use Video File Url" className={styles.field}>
                <Switch
                  defaultChecked={videoUrlActive}
                  onChange={e => setVideoUrlActive(e)}
                />
              </Form.Item>
              {videoUrlActive ? (
                <div className={styles['video-upload']}>
                  <Form.Item
                    label="Video File Url"
                    className={styles.field}
                    name="announcementUrl"
                    initialValue={
                      data?.getAnnouncement?.announcement?.announcementUrl
                    }>
                    <Input
                      style={{width: fieldWidth}}
                      value={announcementUrl}
                      defaultValue={
                        data?.getAnnouncement?.announcement?.announcementUrl
                      }
                      onChange={e => setAnnouncementUrl(e.target.value)}
                      placeholder={'File Url'}
                    />
                  </Form.Item>
                </div>
              ) : (
                <div className={styles['video-upload']}>
                  {videoUrl ? (
                    <div>
                      <Player fluid={false} width={730} src={videoUrl}>
                        <BigPlayButton position="center" />
                      </Player>
                      <div>
                        <Button
                          className={styles['delete-button']}
                          label="Delete Video"
                          onClick={() => setVideoUrl('')}
                        />
                      </div>
                    </div>
                  ) : (
                    <div>
                      <label className={styles.upload} htmlFor="file-upload">
                        {videoUploadLoading ? (
                          <div className={styles['upload-file']}>
                            <Spin />
                            <h2>Uploading Please Wait...</h2>
                            <span>{progress}%</span>
                          </div>
                        ) : (
                          <h2>Upload Announcement Video</h2>
                        )}
                        <input
                          type="file"
                          id="file-upload"
                          className={styles['input-file']}
                          required
                          onChange={handleUploadVideo}
                        />
                      </label>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {(type === 'EVENT' ||
            type === 'GENERAL' ||
            type === 'AUDIO' ||
            type === 'SIMULATOR') && (
            <div>
              <Form.Item
                rules={[
                  {
                    required: false,
                  },
                ]}
                label="Announcement Url"
                className={styles.field}
                name="announcementUrl"
                initialValue={
                  data?.getAnnouncement?.announcement?.announcementUrl
                }>
                <Input
                  style={{width: fieldWidth}}
                  value={announcementUrl}
                  defaultValue={
                    data?.getAnnouncement?.announcement?.announcementUrl
                  }
                  onChange={e => setAnnouncementUrl(e.target.value)}
                  placeholder={'Url'}
                  readOnly={type === 'VIDEO'}
                />
              </Form.Item>
              <Form.Item
                rules={[
                  {
                    required: false,
                  },
                ]}
                label="Open url on click?"
                className={styles.field}
                name="OpenUrlOnClick"
                initialValue={
                  data?.getAnnouncement?.announcement?.openUrlOnClick
                }>
                <Switch
                  defaultChecked={
                    data?.getAnnouncement?.announcement?.openUrlOnClick
                  }
                  onChange={e => setOpenUrl(e)}
                />
              </Form.Item>
            </div>
          )}
          <div className={styles['date-format']}>
            <Form.Item
              label="Published Date (Time is saved in UTC/GMT)"
              name="publishedDate"
              rules={[
                {
                  required: true,
                  message: 'Published date required',
                },
              ]}>
              <DatePicker
                style={{width: 340}}
                format={'YYYY-MM-DD HH:mm:ss'}
                className={styles.publish}
                showTime
                renderExtraFooter={() => (
                  <div style={{textAlign: 'center'}}>
                    <p>Your timezone is: {getUserTimezone()}</p>
                  </div>
                )}
              />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: 'Expiry date required',
                },
              ]}
              name="expiredDate"
              label="Expiration Date (Time is saved in UTC/GMT)">
              <DatePicker
                format={'YYYY-MM-DD HH:mm:ss'}
                style={{width: 340}}
                showTime
                renderExtraFooter={() => (
                  <div style={{textAlign: 'center'}}>
                    <p>Your timezone is: {getUserTimezone()}</p>
                  </div>
                )}
              />
            </Form.Item>
          </div>
          <Collapse defaultActiveKey={['1']} style={{width: '70%'}}>
            <Collapse.Panel
              style={{padding: '10px'}}
              header={<h2>Target Audience</h2>}
              key="1">
              <StepTwoAnnouncement form={form} isEdit />
            </Collapse.Panel>
          </Collapse>
          <SubmitButton disabled={creating} label="Update" />
        </Form>
      </div>
    </div>
  );
};

export {EditAnnouncement};
